import {
	SceneStateActions,
	POINTER_OVER_DROP_AREA,
	SET_SCENE_DATA,
	SELECT_SCENE_ITEM,
	REMOVE_SCENE_ITEM,
	REMOVE_ALL_SCENE_ITEMS,
	ROTATE_SCENE_ITEM,
	MOVE_BACKREST,
	DISABLE_MOVE_BACKREST,
	SET_SCENE_ITEM_COVER,
	SET_COLOR_FOR_ALL,
	DRAG_SCENE_ITEM_ID,
	OVER_SCENE_ITEM_ID,
	ADD_CUSHIONS,
	SET_ENVIRONMENTAL_LIGHTING,
	SET_LIGHT_INTENSITY,
	SET_MEASUREMENTS,
	ANIMATE_CAMERA_ROTATION,
	SET_HELPER_POSITION,
	SELECT_SCENE_ARTICLE,
	RESET_CAMERA_ROTATION,
	SET_KEEP_SCENE_HEIGHT,
	SET_NO_ROTATION_ICON,
	SHOW_ROTATION_ICON,
	REMOVE_SCENE_ITEM_OUTSIDE_SCENE,
	SET_KEEP_MODULE,
	SET_ROTATE_CAMERA,
	MOVE_BACKREST_AS_ARMREST,
	DISABLE_MOVE_BACKREST_AS_ARMREST,
	BACKREST_AS_ARMREST,
	SET_SPECIFIC_SELECTED_ITEMS,
} from './types';
import {
	SofaConfiguration,
	RangeSettings,
	PopOverSceneItemData,
	SceneItemData,
	SceneItemCoverConnection,
	SceneHelperData,
} from 'sofa-reborn-react';
import { ModelData, ProductData, SceneObject } from '@ikea-aoa/component-view-3d';

export function setSceneData(
	sceneItems: SceneItemData[],
	sofaConfiguration: SofaConfiguration,
	articlesPlaceable: { [key: string]: boolean },
	backrestsMissingCushion: boolean,
	rangeSettings: RangeSettings,
	models: ModelData,
	products: ProductData,
	isOverDropArea: boolean
): SceneStateActions {
	return {
		type: SET_SCENE_DATA,
		sceneItems,
		sofaConfiguration,
		articlesPlaceable,
		backrestsMissingCushion,
		rangeSettings,
		models,
		products,
		isOverDropArea,
	};
}

export function selectSceneItem(item: PopOverSceneItemData | null): SceneStateActions {
	return { type: SELECT_SCENE_ITEM, item };
}

export function selectSceneArticle(value: string): SceneStateActions {
	return { type: SELECT_SCENE_ARTICLE, value };
}

export function removeSceneItem(item: SceneItemData): SceneStateActions {
	return { type: REMOVE_SCENE_ITEM, item };
}

export function removeSceneItemOutsideScene(sceneObject: SceneObject): SceneStateActions {
	return { type: REMOVE_SCENE_ITEM_OUTSIDE_SCENE, sceneObject };
}

export function removeAllSceneItems(value: boolean): SceneStateActions {
	return { type: REMOVE_ALL_SCENE_ITEMS, value };
}

export function rotateSceneItem(item: SceneItemData | null): SceneStateActions {
	return { type: ROTATE_SCENE_ITEM, item };
}

export function moveBackrest(item: SceneItemData | null): SceneStateActions {
	return { type: MOVE_BACKREST, item };
}

export function setDisableMoveBackrest(value: boolean): SceneStateActions {
	return { type: DISABLE_MOVE_BACKREST, value };
}

export function moveBackrestAsArmrest(item: SceneItemData | null): SceneStateActions {
	return { type: MOVE_BACKREST_AS_ARMREST, item };
}

export function setDisableMoveBackrestAsArmrest(value: boolean): SceneStateActions {
	return { type: DISABLE_MOVE_BACKREST_AS_ARMREST, value };
}

export function backrestAsArmrest(item: SceneItemData | null): SceneStateActions {
	return { type: BACKREST_AS_ARMREST, item };
}

export function setSceneItemCover(
	sceneItemCoverConnection: SceneItemCoverConnection | null
): SceneStateActions {
	return { type: SET_SCENE_ITEM_COVER, sceneItemCoverConnection };
}

export function setColorForAll(value: string | null): SceneStateActions {
	return { type: SET_COLOR_FOR_ALL, value };
}

export function dragSceneItemId(value: string | null): SceneStateActions {
	return {
		type: DRAG_SCENE_ITEM_ID,
		value,
	};
}

export function overSceneItemId(value: string | null): SceneStateActions {
	return {
		type: OVER_SCENE_ITEM_ID,
		value,
	};
}

export function addCushions(value: boolean): SceneStateActions {
	return { type: ADD_CUSHIONS, value };
}

export function setEnvironmentalLighting(value: string): SceneStateActions {
	return {
		type: SET_ENVIRONMENTAL_LIGHTING,
		value,
	};
}

export function setLightIntensity(value: number): SceneStateActions {
	return {
		type: SET_LIGHT_INTENSITY,
		value,
	};
}

export function animateCameraRotation(value: number | null): SceneStateActions {
	return {
		type: ANIMATE_CAMERA_ROTATION,
		value,
	};
}

export function setMeasurements(value: string): SceneStateActions {
	return {
		type: SET_MEASUREMENTS,
		value,
	};
}

export function pointerOverDropArea(value: boolean): SceneStateActions {
	return {
		type: POINTER_OVER_DROP_AREA,
		value,
	};
}

export function setSceneHelper(value: SceneHelperData): SceneStateActions {
	return { type: SET_HELPER_POSITION, value };
}

export function resetCameraRotation(value: boolean): SceneStateActions {
	return {
		type: RESET_CAMERA_ROTATION,
		value,
	};
}

export function setKeepSceneHeight(value: boolean): SceneStateActions {
	return { type: SET_KEEP_SCENE_HEIGHT, value };
}

export function showRotationIcon(value: boolean): SceneStateActions {
	return { type: SHOW_ROTATION_ICON, value };
}

export function setNoRotationIcon(value: boolean): SceneStateActions {
	return { type: SET_NO_ROTATION_ICON, value };
}

export function setKeepModule(value: boolean): SceneStateActions {
	return { type: SET_KEEP_MODULE, value };
}

export function setRotateCamera(): SceneStateActions {
	return { type: SET_ROTATE_CAMERA };
}

export function setSpecificSelectedItems(items: Map<string, SceneObject>): SceneStateActions {
	return { type: SET_SPECIFIC_SELECTED_ITEMS, items };
}
